/* eslint-disable */
/**
 * AUTO-GENERATED by scripts/generateEctdSections.js - DO NOT EDIT.
 *
 * Canonical eCTD backbone sections parsed from the official DTDs in
 * ./dtd/ (ICH eCTD v3.2.2 for Modules 2-5, EU M1 eCTD for Module 1).
 * See ./dtd/SOURCES.md for provenance. Regenerate with: npm run generate:ectd
 */

export type GeneratedEctdSection = {
  /** DTD element name, e.g. "m3-2-s-4-2-analytical-procedures". */
  key: string;
  /** Human section code, e.g. "3.2.S.4.2", "3.2.R", "1.8.1". */
  code: string;
  /** Title derived from the element name, e.g. "Analytical Procedures". */
  title: string;
  /** CTD module number (1-5). */
  module: number;
  /** Parent section key, or null for module roots. */
  parentKey: string | null;
  /** Child section keys in DTD order. */
  childKeys: string[];
  /** Number of section ancestors (module root = 0). */
  depth: number;
  /** True when the DTD allows the section to repeat (e.g. per manufacturer). */
  repeatable: boolean;
  /** True when the DTD marks the section optional in its parent. */
  optional: boolean;
  /** DTD context attributes, e.g. ["substance", "manufacturer"]. */
  contextAttributes: string[];
};

export const generatedEctdSections: GeneratedEctdSection[] = [
  {
    "key": "m1-administrative-information-and-prescribing-information",
    "code": "1",
    "title": "Administrative Information And Prescribing Information",
    "module": 1,
    "parentKey": null,
    "childKeys": [],
    "depth": 0,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-common-technical-document-summaries",
    "code": "2",
    "title": "Common Technical Document Summaries",
    "module": 2,
    "parentKey": null,
    "childKeys": [
      "m2-2-introduction",
      "m2-3-quality-overall-summary",
      "m2-4-nonclinical-overview",
      "m2-5-clinical-overview",
      "m2-6-nonclinical-written-and-tabulated-summaries",
      "m2-7-clinical-summary"
    ],
    "depth": 0,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-2-introduction",
    "code": "2.2",
    "title": "Introduction",
    "module": 2,
    "parentKey": "m2-common-technical-document-summaries",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-3-quality-overall-summary",
    "code": "2.3",
    "title": "Quality Overall Summary",
    "module": 2,
    "parentKey": "m2-common-technical-document-summaries",
    "childKeys": [
      "m2-3-introduction",
      "m2-3-s-drug-substance",
      "m2-3-p-drug-product",
      "m2-3-a-appendices",
      "m2-3-r-regional-information"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-3-introduction",
    "code": "2.3",
    "title": "Introduction",
    "module": 2,
    "parentKey": "m2-3-quality-overall-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-3-s-drug-substance",
    "code": "2.3.S",
    "title": "Drug Substance",
    "module": 2,
    "parentKey": "m2-3-quality-overall-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": true,
    "optional": true,
    "contextAttributes": [
      "substance",
      "manufacturer"
    ]
  },
  {
    "key": "m2-3-p-drug-product",
    "code": "2.3.P",
    "title": "Drug Product",
    "module": 2,
    "parentKey": "m2-3-quality-overall-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": true,
    "optional": true,
    "contextAttributes": [
      "product-name",
      "dosageform",
      "manufacturer"
    ]
  },
  {
    "key": "m2-3-a-appendices",
    "code": "2.3.A",
    "title": "Appendices",
    "module": 2,
    "parentKey": "m2-3-quality-overall-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-3-r-regional-information",
    "code": "2.3.R",
    "title": "Regional Information",
    "module": 2,
    "parentKey": "m2-3-quality-overall-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-4-nonclinical-overview",
    "code": "2.4",
    "title": "Nonclinical Overview",
    "module": 2,
    "parentKey": "m2-common-technical-document-summaries",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-5-clinical-overview",
    "code": "2.5",
    "title": "Clinical Overview",
    "module": 2,
    "parentKey": "m2-common-technical-document-summaries",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-6-nonclinical-written-and-tabulated-summaries",
    "code": "2.6",
    "title": "Nonclinical Written And Tabulated Summaries",
    "module": 2,
    "parentKey": "m2-common-technical-document-summaries",
    "childKeys": [
      "m2-6-1-introduction",
      "m2-6-2-pharmacology-written-summary",
      "m2-6-3-pharmacology-tabulated-summary",
      "m2-6-4-pharmacokinetics-written-summary",
      "m2-6-5-pharmacokinetics-tabulated-summary",
      "m2-6-6-toxicology-written-summary",
      "m2-6-7-toxicology-tabulated-summary"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-6-1-introduction",
    "code": "2.6.1",
    "title": "Introduction",
    "module": 2,
    "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-6-2-pharmacology-written-summary",
    "code": "2.6.2",
    "title": "Pharmacology Written Summary",
    "module": 2,
    "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-6-3-pharmacology-tabulated-summary",
    "code": "2.6.3",
    "title": "Pharmacology Tabulated Summary",
    "module": 2,
    "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-6-4-pharmacokinetics-written-summary",
    "code": "2.6.4",
    "title": "Pharmacokinetics Written Summary",
    "module": 2,
    "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-6-5-pharmacokinetics-tabulated-summary",
    "code": "2.6.5",
    "title": "Pharmacokinetics Tabulated Summary",
    "module": 2,
    "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-6-6-toxicology-written-summary",
    "code": "2.6.6",
    "title": "Toxicology Written Summary",
    "module": 2,
    "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-6-7-toxicology-tabulated-summary",
    "code": "2.6.7",
    "title": "Toxicology Tabulated Summary",
    "module": 2,
    "parentKey": "m2-6-nonclinical-written-and-tabulated-summaries",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-7-clinical-summary",
    "code": "2.7",
    "title": "Clinical Summary",
    "module": 2,
    "parentKey": "m2-common-technical-document-summaries",
    "childKeys": [
      "m2-7-1-summary-of-biopharmaceutic-studies-and-associated-analytical-methods",
      "m2-7-2-summary-of-clinical-pharmacology-studies",
      "m2-7-3-summary-of-clinical-efficacy",
      "m2-7-4-summary-of-clinical-safety",
      "m2-7-5-literature-references",
      "m2-7-6-synopses-of-individual-studies"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-7-1-summary-of-biopharmaceutic-studies-and-associated-analytical-methods",
    "code": "2.7.1",
    "title": "Summary Of Biopharmaceutic Studies And Associated Analytical Methods",
    "module": 2,
    "parentKey": "m2-7-clinical-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-7-2-summary-of-clinical-pharmacology-studies",
    "code": "2.7.2",
    "title": "Summary Of Clinical Pharmacology Studies",
    "module": 2,
    "parentKey": "m2-7-clinical-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-7-3-summary-of-clinical-efficacy",
    "code": "2.7.3",
    "title": "Summary Of Clinical Efficacy",
    "module": 2,
    "parentKey": "m2-7-clinical-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": true,
    "optional": true,
    "contextAttributes": [
      "indication"
    ]
  },
  {
    "key": "m2-7-4-summary-of-clinical-safety",
    "code": "2.7.4",
    "title": "Summary Of Clinical Safety",
    "module": 2,
    "parentKey": "m2-7-clinical-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-7-5-literature-references",
    "code": "2.7.5",
    "title": "Literature References",
    "module": 2,
    "parentKey": "m2-7-clinical-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m2-7-6-synopses-of-individual-studies",
    "code": "2.7.6",
    "title": "Synopses Of Individual Studies",
    "module": 2,
    "parentKey": "m2-7-clinical-summary",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-quality",
    "code": "3",
    "title": "Quality",
    "module": 3,
    "parentKey": null,
    "childKeys": [
      "m3-2-body-of-data",
      "m3-3-literature-references"
    ],
    "depth": 0,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-body-of-data",
    "code": "3.2",
    "title": "Body Of Data",
    "module": 3,
    "parentKey": "m3-quality",
    "childKeys": [
      "m3-2-s-drug-substance",
      "m3-2-p-drug-product",
      "m3-2-a-appendices",
      "m3-2-r-regional-information"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-drug-substance",
    "code": "3.2.S",
    "title": "Drug Substance",
    "module": 3,
    "parentKey": "m3-2-body-of-data",
    "childKeys": [
      "m3-2-s-1-general-information",
      "m3-2-s-2-manufacture",
      "m3-2-s-3-characterisation",
      "m3-2-s-4-control-of-drug-substance",
      "m3-2-s-5-reference-standards-or-materials",
      "m3-2-s-6-container-closure-system",
      "m3-2-s-7-stability"
    ],
    "depth": 2,
    "repeatable": true,
    "optional": true,
    "contextAttributes": [
      "substance",
      "manufacturer"
    ]
  },
  {
    "key": "m3-2-s-1-general-information",
    "code": "3.2.S.1",
    "title": "General Information",
    "module": 3,
    "parentKey": "m3-2-s-drug-substance",
    "childKeys": [
      "m3-2-s-1-1-nomenclature",
      "m3-2-s-1-2-structure",
      "m3-2-s-1-3-general-properties"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-1-1-nomenclature",
    "code": "3.2.S.1.1",
    "title": "Nomenclature",
    "module": 3,
    "parentKey": "m3-2-s-1-general-information",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-1-2-structure",
    "code": "3.2.S.1.2",
    "title": "Structure",
    "module": 3,
    "parentKey": "m3-2-s-1-general-information",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-1-3-general-properties",
    "code": "3.2.S.1.3",
    "title": "General Properties",
    "module": 3,
    "parentKey": "m3-2-s-1-general-information",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-2-manufacture",
    "code": "3.2.S.2",
    "title": "Manufacture",
    "module": 3,
    "parentKey": "m3-2-s-drug-substance",
    "childKeys": [
      "m3-2-s-2-1-manufacturer",
      "m3-2-s-2-2-description-of-manufacturing-process-and-process-controls",
      "m3-2-s-2-3-control-of-materials",
      "m3-2-s-2-4-controls-of-critical-steps-and-intermediates",
      "m3-2-s-2-5-process-validation-and-or-evaluation",
      "m3-2-s-2-6-manufacturing-process-development"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-2-1-manufacturer",
    "code": "3.2.S.2.1",
    "title": "Manufacturer",
    "module": 3,
    "parentKey": "m3-2-s-2-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-2-2-description-of-manufacturing-process-and-process-controls",
    "code": "3.2.S.2.2",
    "title": "Description Of Manufacturing Process And Process Controls",
    "module": 3,
    "parentKey": "m3-2-s-2-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-2-3-control-of-materials",
    "code": "3.2.S.2.3",
    "title": "Control Of Materials",
    "module": 3,
    "parentKey": "m3-2-s-2-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-2-4-controls-of-critical-steps-and-intermediates",
    "code": "3.2.S.2.4",
    "title": "Controls Of Critical Steps And Intermediates",
    "module": 3,
    "parentKey": "m3-2-s-2-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-2-5-process-validation-and-or-evaluation",
    "code": "3.2.S.2.5",
    "title": "Process Validation And/Or Evaluation",
    "module": 3,
    "parentKey": "m3-2-s-2-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-2-6-manufacturing-process-development",
    "code": "3.2.S.2.6",
    "title": "Manufacturing Process Development",
    "module": 3,
    "parentKey": "m3-2-s-2-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-3-characterisation",
    "code": "3.2.S.3",
    "title": "Characterisation",
    "module": 3,
    "parentKey": "m3-2-s-drug-substance",
    "childKeys": [
      "m3-2-s-3-1-elucidation-of-structure-and-other-characteristics",
      "m3-2-s-3-2-impurities"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-3-1-elucidation-of-structure-and-other-characteristics",
    "code": "3.2.S.3.1",
    "title": "Elucidation Of Structure And Other Characteristics",
    "module": 3,
    "parentKey": "m3-2-s-3-characterisation",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-3-2-impurities",
    "code": "3.2.S.3.2",
    "title": "Impurities",
    "module": 3,
    "parentKey": "m3-2-s-3-characterisation",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-4-control-of-drug-substance",
    "code": "3.2.S.4",
    "title": "Control Of Drug Substance",
    "module": 3,
    "parentKey": "m3-2-s-drug-substance",
    "childKeys": [
      "m3-2-s-4-1-specification",
      "m3-2-s-4-2-analytical-procedures",
      "m3-2-s-4-3-validation-of-analytical-procedures",
      "m3-2-s-4-4-batch-analyses",
      "m3-2-s-4-5-justification-of-specification"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-4-1-specification",
    "code": "3.2.S.4.1",
    "title": "Specification",
    "module": 3,
    "parentKey": "m3-2-s-4-control-of-drug-substance",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-4-2-analytical-procedures",
    "code": "3.2.S.4.2",
    "title": "Analytical Procedures",
    "module": 3,
    "parentKey": "m3-2-s-4-control-of-drug-substance",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-4-3-validation-of-analytical-procedures",
    "code": "3.2.S.4.3",
    "title": "Validation Of Analytical Procedures",
    "module": 3,
    "parentKey": "m3-2-s-4-control-of-drug-substance",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-4-4-batch-analyses",
    "code": "3.2.S.4.4",
    "title": "Batch Analyses",
    "module": 3,
    "parentKey": "m3-2-s-4-control-of-drug-substance",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-4-5-justification-of-specification",
    "code": "3.2.S.4.5",
    "title": "Justification Of Specification",
    "module": 3,
    "parentKey": "m3-2-s-4-control-of-drug-substance",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-5-reference-standards-or-materials",
    "code": "3.2.S.5",
    "title": "Reference Standards Or Materials",
    "module": 3,
    "parentKey": "m3-2-s-drug-substance",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-6-container-closure-system",
    "code": "3.2.S.6",
    "title": "Container Closure System",
    "module": 3,
    "parentKey": "m3-2-s-drug-substance",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-7-stability",
    "code": "3.2.S.7",
    "title": "Stability",
    "module": 3,
    "parentKey": "m3-2-s-drug-substance",
    "childKeys": [
      "m3-2-s-7-1-stability-summary-and-conclusions",
      "m3-2-s-7-2-post-approval-stability-protocol-and-stability-commitment",
      "m3-2-s-7-3-stability-data"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-7-1-stability-summary-and-conclusions",
    "code": "3.2.S.7.1",
    "title": "Stability Summary And Conclusions",
    "module": 3,
    "parentKey": "m3-2-s-7-stability",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-7-2-post-approval-stability-protocol-and-stability-commitment",
    "code": "3.2.S.7.2",
    "title": "Post Approval Stability Protocol And Stability Commitment",
    "module": 3,
    "parentKey": "m3-2-s-7-stability",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-s-7-3-stability-data",
    "code": "3.2.S.7.3",
    "title": "Stability Data",
    "module": 3,
    "parentKey": "m3-2-s-7-stability",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-drug-product",
    "code": "3.2.P",
    "title": "Drug Product",
    "module": 3,
    "parentKey": "m3-2-body-of-data",
    "childKeys": [
      "m3-2-p-1-description-and-composition-of-the-drug-product",
      "m3-2-p-2-pharmaceutical-development",
      "m3-2-p-3-manufacture",
      "m3-2-p-4-control-of-excipients",
      "m3-2-p-5-control-of-drug-product",
      "m3-2-p-6-reference-standards-or-materials",
      "m3-2-p-7-container-closure-system",
      "m3-2-p-8-stability"
    ],
    "depth": 2,
    "repeatable": true,
    "optional": true,
    "contextAttributes": [
      "product-name",
      "dosageform",
      "manufacturer"
    ]
  },
  {
    "key": "m3-2-p-1-description-and-composition-of-the-drug-product",
    "code": "3.2.P.1",
    "title": "Description And Composition Of The Drug Product",
    "module": 3,
    "parentKey": "m3-2-p-drug-product",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-2-pharmaceutical-development",
    "code": "3.2.P.2",
    "title": "Pharmaceutical Development",
    "module": 3,
    "parentKey": "m3-2-p-drug-product",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-3-manufacture",
    "code": "3.2.P.3",
    "title": "Manufacture",
    "module": 3,
    "parentKey": "m3-2-p-drug-product",
    "childKeys": [
      "m3-2-p-3-1-manufacturers",
      "m3-2-p-3-2-batch-formula",
      "m3-2-p-3-3-description-of-manufacturing-process-and-process-controls",
      "m3-2-p-3-4-controls-of-critical-steps-and-intermediates",
      "m3-2-p-3-5-process-validation-and-or-evaluation"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-3-1-manufacturers",
    "code": "3.2.P.3.1",
    "title": "Manufacturers",
    "module": 3,
    "parentKey": "m3-2-p-3-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-3-2-batch-formula",
    "code": "3.2.P.3.2",
    "title": "Batch Formula",
    "module": 3,
    "parentKey": "m3-2-p-3-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-3-3-description-of-manufacturing-process-and-process-controls",
    "code": "3.2.P.3.3",
    "title": "Description Of Manufacturing Process And Process Controls",
    "module": 3,
    "parentKey": "m3-2-p-3-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-3-4-controls-of-critical-steps-and-intermediates",
    "code": "3.2.P.3.4",
    "title": "Controls Of Critical Steps And Intermediates",
    "module": 3,
    "parentKey": "m3-2-p-3-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-3-5-process-validation-and-or-evaluation",
    "code": "3.2.P.3.5",
    "title": "Process Validation And/Or Evaluation",
    "module": 3,
    "parentKey": "m3-2-p-3-manufacture",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-4-control-of-excipients",
    "code": "3.2.P.4",
    "title": "Control Of Excipients",
    "module": 3,
    "parentKey": "m3-2-p-drug-product",
    "childKeys": [
      "m3-2-p-4-1-specifications",
      "m3-2-p-4-2-analytical-procedures",
      "m3-2-p-4-3-validation-of-analytical-procedures",
      "m3-2-p-4-4-justification-of-specifications",
      "m3-2-p-4-5-excipients-of-human-or-animal-origin",
      "m3-2-p-4-6-novel-excipients"
    ],
    "depth": 3,
    "repeatable": true,
    "optional": true,
    "contextAttributes": [
      "excipient"
    ]
  },
  {
    "key": "m3-2-p-4-1-specifications",
    "code": "3.2.P.4.1",
    "title": "Specifications",
    "module": 3,
    "parentKey": "m3-2-p-4-control-of-excipients",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-4-2-analytical-procedures",
    "code": "3.2.P.4.2",
    "title": "Analytical Procedures",
    "module": 3,
    "parentKey": "m3-2-p-4-control-of-excipients",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-4-3-validation-of-analytical-procedures",
    "code": "3.2.P.4.3",
    "title": "Validation Of Analytical Procedures",
    "module": 3,
    "parentKey": "m3-2-p-4-control-of-excipients",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-4-4-justification-of-specifications",
    "code": "3.2.P.4.4",
    "title": "Justification Of Specifications",
    "module": 3,
    "parentKey": "m3-2-p-4-control-of-excipients",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-4-5-excipients-of-human-or-animal-origin",
    "code": "3.2.P.4.5",
    "title": "Excipients Of Human Or Animal Origin",
    "module": 3,
    "parentKey": "m3-2-p-4-control-of-excipients",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-4-6-novel-excipients",
    "code": "3.2.P.4.6",
    "title": "Novel Excipients",
    "module": 3,
    "parentKey": "m3-2-p-4-control-of-excipients",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-5-control-of-drug-product",
    "code": "3.2.P.5",
    "title": "Control Of Drug Product",
    "module": 3,
    "parentKey": "m3-2-p-drug-product",
    "childKeys": [
      "m3-2-p-5-1-specifications",
      "m3-2-p-5-2-analytical-procedures",
      "m3-2-p-5-3-validation-of-analytical-procedures",
      "m3-2-p-5-4-batch-analyses",
      "m3-2-p-5-5-characterisation-of-impurities",
      "m3-2-p-5-6-justification-of-specifications"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-5-1-specifications",
    "code": "3.2.P.5.1",
    "title": "Specifications",
    "module": 3,
    "parentKey": "m3-2-p-5-control-of-drug-product",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-5-2-analytical-procedures",
    "code": "3.2.P.5.2",
    "title": "Analytical Procedures",
    "module": 3,
    "parentKey": "m3-2-p-5-control-of-drug-product",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-5-3-validation-of-analytical-procedures",
    "code": "3.2.P.5.3",
    "title": "Validation Of Analytical Procedures",
    "module": 3,
    "parentKey": "m3-2-p-5-control-of-drug-product",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-5-4-batch-analyses",
    "code": "3.2.P.5.4",
    "title": "Batch Analyses",
    "module": 3,
    "parentKey": "m3-2-p-5-control-of-drug-product",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-5-5-characterisation-of-impurities",
    "code": "3.2.P.5.5",
    "title": "Characterisation Of Impurities",
    "module": 3,
    "parentKey": "m3-2-p-5-control-of-drug-product",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-5-6-justification-of-specifications",
    "code": "3.2.P.5.6",
    "title": "Justification Of Specifications",
    "module": 3,
    "parentKey": "m3-2-p-5-control-of-drug-product",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-6-reference-standards-or-materials",
    "code": "3.2.P.6",
    "title": "Reference Standards Or Materials",
    "module": 3,
    "parentKey": "m3-2-p-drug-product",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-7-container-closure-system",
    "code": "3.2.P.7",
    "title": "Container Closure System",
    "module": 3,
    "parentKey": "m3-2-p-drug-product",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-8-stability",
    "code": "3.2.P.8",
    "title": "Stability",
    "module": 3,
    "parentKey": "m3-2-p-drug-product",
    "childKeys": [
      "m3-2-p-8-1-stability-summary-and-conclusion",
      "m3-2-p-8-2-post-approval-stability-protocol-and-stability-commitment",
      "m3-2-p-8-3-stability-data"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-8-1-stability-summary-and-conclusion",
    "code": "3.2.P.8.1",
    "title": "Stability Summary And Conclusion",
    "module": 3,
    "parentKey": "m3-2-p-8-stability",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-8-2-post-approval-stability-protocol-and-stability-commitment",
    "code": "3.2.P.8.2",
    "title": "Post Approval Stability Protocol And Stability Commitment",
    "module": 3,
    "parentKey": "m3-2-p-8-stability",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-p-8-3-stability-data",
    "code": "3.2.P.8.3",
    "title": "Stability Data",
    "module": 3,
    "parentKey": "m3-2-p-8-stability",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-a-appendices",
    "code": "3.2.A",
    "title": "Appendices",
    "module": 3,
    "parentKey": "m3-2-body-of-data",
    "childKeys": [
      "m3-2-a-1-facilities-and-equipment",
      "m3-2-a-2-adventitious-agents-safety-evaluation",
      "m3-2-a-3-excipients"
    ],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-a-1-facilities-and-equipment",
    "code": "3.2.A.1",
    "title": "Facilities And Equipment",
    "module": 3,
    "parentKey": "m3-2-a-appendices",
    "childKeys": [],
    "depth": 3,
    "repeatable": true,
    "optional": true,
    "contextAttributes": [
      "manufacturer",
      "substance",
      "dosageform",
      "product-name"
    ]
  },
  {
    "key": "m3-2-a-2-adventitious-agents-safety-evaluation",
    "code": "3.2.A.2",
    "title": "Adventitious Agents Safety Evaluation",
    "module": 3,
    "parentKey": "m3-2-a-appendices",
    "childKeys": [],
    "depth": 3,
    "repeatable": true,
    "optional": true,
    "contextAttributes": [
      "manufacturer",
      "substance",
      "dosageform",
      "product-name"
    ]
  },
  {
    "key": "m3-2-a-3-excipients",
    "code": "3.2.A.3",
    "title": "Excipients",
    "module": 3,
    "parentKey": "m3-2-a-appendices",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-2-r-regional-information",
    "code": "3.2.R",
    "title": "Regional Information",
    "module": 3,
    "parentKey": "m3-2-body-of-data",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m3-3-literature-references",
    "code": "3.3",
    "title": "Literature References",
    "module": 3,
    "parentKey": "m3-quality",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-nonclinical-study-reports",
    "code": "4",
    "title": "Nonclinical Study Reports",
    "module": 4,
    "parentKey": null,
    "childKeys": [
      "m4-2-study-reports",
      "m4-3-literature-references"
    ],
    "depth": 0,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-study-reports",
    "code": "4.2",
    "title": "Study Reports",
    "module": 4,
    "parentKey": "m4-nonclinical-study-reports",
    "childKeys": [
      "m4-2-1-pharmacology",
      "m4-2-2-pharmacokinetics",
      "m4-2-3-toxicology"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-1-pharmacology",
    "code": "4.2.1",
    "title": "Pharmacology",
    "module": 4,
    "parentKey": "m4-2-study-reports",
    "childKeys": [
      "m4-2-1-1-primary-pharmacodynamics",
      "m4-2-1-2-secondary-pharmacodynamics",
      "m4-2-1-3-safety-pharmacology",
      "m4-2-1-4-pharmacodynamic-drug-interactions"
    ],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-1-1-primary-pharmacodynamics",
    "code": "4.2.1.1",
    "title": "Primary Pharmacodynamics",
    "module": 4,
    "parentKey": "m4-2-1-pharmacology",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-1-2-secondary-pharmacodynamics",
    "code": "4.2.1.2",
    "title": "Secondary Pharmacodynamics",
    "module": 4,
    "parentKey": "m4-2-1-pharmacology",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-1-3-safety-pharmacology",
    "code": "4.2.1.3",
    "title": "Safety Pharmacology",
    "module": 4,
    "parentKey": "m4-2-1-pharmacology",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-1-4-pharmacodynamic-drug-interactions",
    "code": "4.2.1.4",
    "title": "Pharmacodynamic Drug Interactions",
    "module": 4,
    "parentKey": "m4-2-1-pharmacology",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-2-pharmacokinetics",
    "code": "4.2.2",
    "title": "Pharmacokinetics",
    "module": 4,
    "parentKey": "m4-2-study-reports",
    "childKeys": [
      "m4-2-2-1-analytical-methods-and-validation-reports",
      "m4-2-2-2-absorption",
      "m4-2-2-3-distribution",
      "m4-2-2-4-metabolism",
      "m4-2-2-5-excretion",
      "m4-2-2-6-pharmacokinetic-drug-interactions",
      "m4-2-2-7-other-pharmacokinetic-studies"
    ],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-2-1-analytical-methods-and-validation-reports",
    "code": "4.2.2.1",
    "title": "Analytical Methods And Validation Reports",
    "module": 4,
    "parentKey": "m4-2-2-pharmacokinetics",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-2-2-absorption",
    "code": "4.2.2.2",
    "title": "Absorption",
    "module": 4,
    "parentKey": "m4-2-2-pharmacokinetics",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-2-3-distribution",
    "code": "4.2.2.3",
    "title": "Distribution",
    "module": 4,
    "parentKey": "m4-2-2-pharmacokinetics",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-2-4-metabolism",
    "code": "4.2.2.4",
    "title": "Metabolism",
    "module": 4,
    "parentKey": "m4-2-2-pharmacokinetics",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-2-5-excretion",
    "code": "4.2.2.5",
    "title": "Excretion",
    "module": 4,
    "parentKey": "m4-2-2-pharmacokinetics",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-2-6-pharmacokinetic-drug-interactions",
    "code": "4.2.2.6",
    "title": "Pharmacokinetic Drug Interactions",
    "module": 4,
    "parentKey": "m4-2-2-pharmacokinetics",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-2-7-other-pharmacokinetic-studies",
    "code": "4.2.2.7",
    "title": "Other Pharmacokinetic Studies",
    "module": 4,
    "parentKey": "m4-2-2-pharmacokinetics",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-toxicology",
    "code": "4.2.3",
    "title": "Toxicology",
    "module": 4,
    "parentKey": "m4-2-study-reports",
    "childKeys": [
      "m4-2-3-1-single-dose-toxicity",
      "m4-2-3-2-repeat-dose-toxicity",
      "m4-2-3-3-genotoxicity",
      "m4-2-3-4-carcinogenicity",
      "m4-2-3-5-reproductive-and-developmental-toxicity",
      "m4-2-3-6-local-tolerance",
      "m4-2-3-7-other-toxicity-studies"
    ],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-1-single-dose-toxicity",
    "code": "4.2.3.1",
    "title": "Single Dose Toxicity",
    "module": 4,
    "parentKey": "m4-2-3-toxicology",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-2-repeat-dose-toxicity",
    "code": "4.2.3.2",
    "title": "Repeat Dose Toxicity",
    "module": 4,
    "parentKey": "m4-2-3-toxicology",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-3-genotoxicity",
    "code": "4.2.3.3",
    "title": "Genotoxicity",
    "module": 4,
    "parentKey": "m4-2-3-toxicology",
    "childKeys": [
      "m4-2-3-3-1-in-vitro",
      "m4-2-3-3-2-in-vivo"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-3-1-in-vitro",
    "code": "4.2.3.3.1",
    "title": "In Vitro",
    "module": 4,
    "parentKey": "m4-2-3-3-genotoxicity",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-3-2-in-vivo",
    "code": "4.2.3.3.2",
    "title": "In Vivo",
    "module": 4,
    "parentKey": "m4-2-3-3-genotoxicity",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-4-carcinogenicity",
    "code": "4.2.3.4",
    "title": "Carcinogenicity",
    "module": 4,
    "parentKey": "m4-2-3-toxicology",
    "childKeys": [
      "m4-2-3-4-1-long-term-studies",
      "m4-2-3-4-2-short-or-medium-term-studies",
      "m4-2-3-4-3-other-studies"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-4-1-long-term-studies",
    "code": "4.2.3.4.1",
    "title": "Long Term Studies",
    "module": 4,
    "parentKey": "m4-2-3-4-carcinogenicity",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-4-2-short-or-medium-term-studies",
    "code": "4.2.3.4.2",
    "title": "Short Or Medium Term Studies",
    "module": 4,
    "parentKey": "m4-2-3-4-carcinogenicity",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-4-3-other-studies",
    "code": "4.2.3.4.3",
    "title": "Other Studies",
    "module": 4,
    "parentKey": "m4-2-3-4-carcinogenicity",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-5-reproductive-and-developmental-toxicity",
    "code": "4.2.3.5",
    "title": "Reproductive And Developmental Toxicity",
    "module": 4,
    "parentKey": "m4-2-3-toxicology",
    "childKeys": [
      "m4-2-3-5-1-fertility-and-early-embryonic-development",
      "m4-2-3-5-2-embryo-fetal-development",
      "m4-2-3-5-3-prenatal-and-postnatal-development-including-maternal-function",
      "m4-2-3-5-4-studies-in-which-the-offspring-juvenile-animals-are-dosed-and-or-further-evaluated"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-5-1-fertility-and-early-embryonic-development",
    "code": "4.2.3.5.1",
    "title": "Fertility And Early Embryonic Development",
    "module": 4,
    "parentKey": "m4-2-3-5-reproductive-and-developmental-toxicity",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-5-2-embryo-fetal-development",
    "code": "4.2.3.5.2",
    "title": "Embryo Fetal Development",
    "module": 4,
    "parentKey": "m4-2-3-5-reproductive-and-developmental-toxicity",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-5-3-prenatal-and-postnatal-development-including-maternal-function",
    "code": "4.2.3.5.3",
    "title": "Prenatal And Postnatal Development Including Maternal Function",
    "module": 4,
    "parentKey": "m4-2-3-5-reproductive-and-developmental-toxicity",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-5-4-studies-in-which-the-offspring-juvenile-animals-are-dosed-and-or-further-evaluated",
    "code": "4.2.3.5.4",
    "title": "Studies In Which The Offspring Juvenile Animals Are Dosed And/Or Further Evaluated",
    "module": 4,
    "parentKey": "m4-2-3-5-reproductive-and-developmental-toxicity",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-6-local-tolerance",
    "code": "4.2.3.6",
    "title": "Local Tolerance",
    "module": 4,
    "parentKey": "m4-2-3-toxicology",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-7-other-toxicity-studies",
    "code": "4.2.3.7",
    "title": "Other Toxicity Studies",
    "module": 4,
    "parentKey": "m4-2-3-toxicology",
    "childKeys": [
      "m4-2-3-7-1-antigenicity",
      "m4-2-3-7-2-immunotoxicity",
      "m4-2-3-7-3-mechanistic-studies",
      "m4-2-3-7-4-dependence",
      "m4-2-3-7-5-metabolites",
      "m4-2-3-7-6-impurities",
      "m4-2-3-7-7-other"
    ],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-7-1-antigenicity",
    "code": "4.2.3.7.1",
    "title": "Antigenicity",
    "module": 4,
    "parentKey": "m4-2-3-7-other-toxicity-studies",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-7-2-immunotoxicity",
    "code": "4.2.3.7.2",
    "title": "Immunotoxicity",
    "module": 4,
    "parentKey": "m4-2-3-7-other-toxicity-studies",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-7-3-mechanistic-studies",
    "code": "4.2.3.7.3",
    "title": "Mechanistic Studies",
    "module": 4,
    "parentKey": "m4-2-3-7-other-toxicity-studies",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-7-4-dependence",
    "code": "4.2.3.7.4",
    "title": "Dependence",
    "module": 4,
    "parentKey": "m4-2-3-7-other-toxicity-studies",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-7-5-metabolites",
    "code": "4.2.3.7.5",
    "title": "Metabolites",
    "module": 4,
    "parentKey": "m4-2-3-7-other-toxicity-studies",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-7-6-impurities",
    "code": "4.2.3.7.6",
    "title": "Impurities",
    "module": 4,
    "parentKey": "m4-2-3-7-other-toxicity-studies",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-2-3-7-7-other",
    "code": "4.2.3.7.7",
    "title": "Other",
    "module": 4,
    "parentKey": "m4-2-3-7-other-toxicity-studies",
    "childKeys": [],
    "depth": 4,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m4-3-literature-references",
    "code": "4.3",
    "title": "Literature References",
    "module": 4,
    "parentKey": "m4-nonclinical-study-reports",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-clinical-study-reports",
    "code": "5",
    "title": "Clinical Study Reports",
    "module": 5,
    "parentKey": null,
    "childKeys": [
      "m5-2-tabular-listing-of-all-clinical-studies",
      "m5-3-clinical-study-reports",
      "m5-4-literature-references"
    ],
    "depth": 0,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-2-tabular-listing-of-all-clinical-studies",
    "code": "5.2",
    "title": "Tabular Listing Of All Clinical Studies",
    "module": 5,
    "parentKey": "m5-clinical-study-reports",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-clinical-study-reports",
    "code": "5.3",
    "title": "Clinical Study Reports",
    "module": 5,
    "parentKey": "m5-clinical-study-reports",
    "childKeys": [
      "m5-3-1-reports-of-biopharmaceutic-studies",
      "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
      "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
      "m5-3-4-reports-of-human-pharmacodynamics-pd-studies",
      "m5-3-5-reports-of-efficacy-and-safety-studies",
      "m5-3-6-reports-of-postmarketing-experience",
      "m5-3-7-case-report-forms-and-individual-patient-listings"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-1-reports-of-biopharmaceutic-studies",
    "code": "5.3.1",
    "title": "Reports Of Biopharmaceutic Studies",
    "module": 5,
    "parentKey": "m5-3-clinical-study-reports",
    "childKeys": [
      "m5-3-1-1-bioavailability-study-reports",
      "m5-3-1-2-comparative-ba-and-bioequivalence-study-reports",
      "m5-3-1-3-in-vitro-in-vivo-correlation-study-reports",
      "m5-3-1-4-reports-of-bioanalytical-and-analytical-methods-for-human-studies"
    ],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-1-1-bioavailability-study-reports",
    "code": "5.3.1.1",
    "title": "Bioavailability Study Reports",
    "module": 5,
    "parentKey": "m5-3-1-reports-of-biopharmaceutic-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-1-2-comparative-ba-and-bioequivalence-study-reports",
    "code": "5.3.1.2",
    "title": "Comparative Ba And Bioequivalence Study Reports",
    "module": 5,
    "parentKey": "m5-3-1-reports-of-biopharmaceutic-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-1-3-in-vitro-in-vivo-correlation-study-reports",
    "code": "5.3.1.3",
    "title": "In Vitro In Vivo Correlation Study Reports",
    "module": 5,
    "parentKey": "m5-3-1-reports-of-biopharmaceutic-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-1-4-reports-of-bioanalytical-and-analytical-methods-for-human-studies",
    "code": "5.3.1.4",
    "title": "Reports Of Bioanalytical And Analytical Methods For Human Studies",
    "module": 5,
    "parentKey": "m5-3-1-reports-of-biopharmaceutic-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
    "code": "5.3.2",
    "title": "Reports Of Studies Pertinent To Pharmacokinetics Using Human Biomaterials",
    "module": 5,
    "parentKey": "m5-3-clinical-study-reports",
    "childKeys": [
      "m5-3-2-1-plasma-protein-binding-study-reports",
      "m5-3-2-2-reports-of-hepatic-metabolism-and-drug-interaction-studies",
      "m5-3-2-3-reports-of-studies-using-other-human-biomaterials"
    ],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-2-1-plasma-protein-binding-study-reports",
    "code": "5.3.2.1",
    "title": "Plasma Protein Binding Study Reports",
    "module": 5,
    "parentKey": "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-2-2-reports-of-hepatic-metabolism-and-drug-interaction-studies",
    "code": "5.3.2.2",
    "title": "Reports Of Hepatic Metabolism And Drug Interaction Studies",
    "module": 5,
    "parentKey": "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-2-3-reports-of-studies-using-other-human-biomaterials",
    "code": "5.3.2.3",
    "title": "Reports Of Studies Using Other Human Biomaterials",
    "module": 5,
    "parentKey": "m5-3-2-reports-of-studies-pertinent-to-pharmacokinetics-using-human-biomaterials",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
    "code": "5.3.3",
    "title": "Reports Of Human Pharmacokinetics Pk Studies",
    "module": 5,
    "parentKey": "m5-3-clinical-study-reports",
    "childKeys": [
      "m5-3-3-1-healthy-subject-pk-and-initial-tolerability-study-reports",
      "m5-3-3-2-patient-pk-and-initial-tolerability-study-reports",
      "m5-3-3-3-intrinsic-factor-pk-study-reports",
      "m5-3-3-4-extrinsic-factor-pk-study-reports",
      "m5-3-3-5-population-pk-study-reports"
    ],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-3-1-healthy-subject-pk-and-initial-tolerability-study-reports",
    "code": "5.3.3.1",
    "title": "Healthy Subject Pk And Initial Tolerability Study Reports",
    "module": 5,
    "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-3-2-patient-pk-and-initial-tolerability-study-reports",
    "code": "5.3.3.2",
    "title": "Patient Pk And Initial Tolerability Study Reports",
    "module": 5,
    "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-3-3-intrinsic-factor-pk-study-reports",
    "code": "5.3.3.3",
    "title": "Intrinsic Factor Pk Study Reports",
    "module": 5,
    "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-3-4-extrinsic-factor-pk-study-reports",
    "code": "5.3.3.4",
    "title": "Extrinsic Factor Pk Study Reports",
    "module": 5,
    "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-3-5-population-pk-study-reports",
    "code": "5.3.3.5",
    "title": "Population Pk Study Reports",
    "module": 5,
    "parentKey": "m5-3-3-reports-of-human-pharmacokinetics-pk-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-4-reports-of-human-pharmacodynamics-pd-studies",
    "code": "5.3.4",
    "title": "Reports Of Human Pharmacodynamics Pd Studies",
    "module": 5,
    "parentKey": "m5-3-clinical-study-reports",
    "childKeys": [
      "m5-3-4-1-healthy-subject-pd-and-pk-pd-study-reports",
      "m5-3-4-2-patient-pd-and-pk-pd-study-reports"
    ],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-4-1-healthy-subject-pd-and-pk-pd-study-reports",
    "code": "5.3.4.1",
    "title": "Healthy Subject Pd And Pk Pd Study Reports",
    "module": 5,
    "parentKey": "m5-3-4-reports-of-human-pharmacodynamics-pd-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-4-2-patient-pd-and-pk-pd-study-reports",
    "code": "5.3.4.2",
    "title": "Patient Pd And Pk Pd Study Reports",
    "module": 5,
    "parentKey": "m5-3-4-reports-of-human-pharmacodynamics-pd-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-5-reports-of-efficacy-and-safety-studies",
    "code": "5.3.5",
    "title": "Reports Of Efficacy And Safety Studies",
    "module": 5,
    "parentKey": "m5-3-clinical-study-reports",
    "childKeys": [
      "m5-3-5-1-study-reports-of-controlled-clinical-studies-pertinent-to-the-claimed-indication",
      "m5-3-5-2-study-reports-of-uncontrolled-clinical-studies",
      "m5-3-5-3-reports-of-analyses-of-data-from-more-than-one-study",
      "m5-3-5-4-other-study-reports"
    ],
    "depth": 2,
    "repeatable": true,
    "optional": true,
    "contextAttributes": [
      "indication"
    ]
  },
  {
    "key": "m5-3-5-1-study-reports-of-controlled-clinical-studies-pertinent-to-the-claimed-indication",
    "code": "5.3.5.1",
    "title": "Study Reports Of Controlled Clinical Studies Pertinent To The Claimed Indication",
    "module": 5,
    "parentKey": "m5-3-5-reports-of-efficacy-and-safety-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-5-2-study-reports-of-uncontrolled-clinical-studies",
    "code": "5.3.5.2",
    "title": "Study Reports Of Uncontrolled Clinical Studies",
    "module": 5,
    "parentKey": "m5-3-5-reports-of-efficacy-and-safety-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-5-3-reports-of-analyses-of-data-from-more-than-one-study",
    "code": "5.3.5.3",
    "title": "Reports Of Analyses Of Data From More Than One Study",
    "module": 5,
    "parentKey": "m5-3-5-reports-of-efficacy-and-safety-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-5-4-other-study-reports",
    "code": "5.3.5.4",
    "title": "Other Study Reports",
    "module": 5,
    "parentKey": "m5-3-5-reports-of-efficacy-and-safety-studies",
    "childKeys": [],
    "depth": 3,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-6-reports-of-postmarketing-experience",
    "code": "5.3.6",
    "title": "Reports Of Postmarketing Experience",
    "module": 5,
    "parentKey": "m5-3-clinical-study-reports",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-3-7-case-report-forms-and-individual-patient-listings",
    "code": "5.3.7",
    "title": "Case Report Forms And Individual Patient Listings",
    "module": 5,
    "parentKey": "m5-3-clinical-study-reports",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m5-4-literature-references",
    "code": "5.4",
    "title": "Literature References",
    "module": 5,
    "parentKey": "m5-clinical-study-reports",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-eu",
    "code": "1",
    "title": "Eu",
    "module": 1,
    "parentKey": null,
    "childKeys": [
      "m1-0-cover",
      "m1-2-form",
      "m1-3-pi",
      "m1-4-expert",
      "m1-5-specific",
      "m1-6-environrisk",
      "m1-7-orphan",
      "m1-8-pharmacovigilance",
      "m1-9-clinical-trials",
      "m1-10-paediatrics",
      "m1-responses",
      "m1-additional-data"
    ],
    "depth": 0,
    "repeatable": false,
    "optional": false,
    "contextAttributes": []
  },
  {
    "key": "m1-0-cover",
    "code": "1.0",
    "title": "Cover",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": false,
    "contextAttributes": []
  },
  {
    "key": "m1-2-form",
    "code": "1.2",
    "title": "Form",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-3-pi",
    "code": "1.3",
    "title": "Pi",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [
      "m1-3-1-spc-label-pl",
      "m1-3-2-mockup",
      "m1-3-3-specimen",
      "m1-3-4-consultation",
      "m1-3-5-approved",
      "m1-3-6-braille"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-3-1-spc-label-pl",
    "code": "1.3.1",
    "title": "Spc Label Pl",
    "module": 1,
    "parentKey": "m1-3-pi",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-3-2-mockup",
    "code": "1.3.2",
    "title": "Mockup",
    "module": 1,
    "parentKey": "m1-3-pi",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-3-3-specimen",
    "code": "1.3.3",
    "title": "Specimen",
    "module": 1,
    "parentKey": "m1-3-pi",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-3-4-consultation",
    "code": "1.3.4",
    "title": "Consultation",
    "module": 1,
    "parentKey": "m1-3-pi",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-3-5-approved",
    "code": "1.3.5",
    "title": "Approved",
    "module": 1,
    "parentKey": "m1-3-pi",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-3-6-braille",
    "code": "1.3.6",
    "title": "Braille",
    "module": 1,
    "parentKey": "m1-3-pi",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-4-expert",
    "code": "1.4",
    "title": "Expert",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [
      "m1-4-1-quality",
      "m1-4-2-non-clinical",
      "m1-4-3-clinical"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-4-1-quality",
    "code": "1.4.1",
    "title": "Quality",
    "module": 1,
    "parentKey": "m1-4-expert",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-4-2-non-clinical",
    "code": "1.4.2",
    "title": "Non Clinical",
    "module": 1,
    "parentKey": "m1-4-expert",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-4-3-clinical",
    "code": "1.4.3",
    "title": "Clinical",
    "module": 1,
    "parentKey": "m1-4-expert",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-5-specific",
    "code": "1.5",
    "title": "Specific",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [
      "m1-5-1-bibliographic",
      "m1-5-2-generic-hybrid-bio-similar",
      "m1-5-3-data-market-exclusivity",
      "m1-5-4-exceptional-circumstances",
      "m1-5-5-conditional-ma"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-5-1-bibliographic",
    "code": "1.5.1",
    "title": "Bibliographic",
    "module": 1,
    "parentKey": "m1-5-specific",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-5-2-generic-hybrid-bio-similar",
    "code": "1.5.2",
    "title": "Generic Hybrid Bio Similar",
    "module": 1,
    "parentKey": "m1-5-specific",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-5-3-data-market-exclusivity",
    "code": "1.5.3",
    "title": "Data Market Exclusivity",
    "module": 1,
    "parentKey": "m1-5-specific",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-5-4-exceptional-circumstances",
    "code": "1.5.4",
    "title": "Exceptional Circumstances",
    "module": 1,
    "parentKey": "m1-5-specific",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-5-5-conditional-ma",
    "code": "1.5.5",
    "title": "Conditional Ma",
    "module": 1,
    "parentKey": "m1-5-specific",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-6-environrisk",
    "code": "1.6",
    "title": "Environrisk",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [
      "m1-6-1-non-gmo",
      "m1-6-2-gmo"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-6-1-non-gmo",
    "code": "1.6.1",
    "title": "Non Gmo",
    "module": 1,
    "parentKey": "m1-6-environrisk",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": false,
    "contextAttributes": []
  },
  {
    "key": "m1-6-2-gmo",
    "code": "1.6.2",
    "title": "Gmo",
    "module": 1,
    "parentKey": "m1-6-environrisk",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": false,
    "contextAttributes": []
  },
  {
    "key": "m1-7-orphan",
    "code": "1.7",
    "title": "Orphan",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [
      "m1-7-1-similarity",
      "m1-7-2-market-exclusivity"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-7-1-similarity",
    "code": "1.7.1",
    "title": "Similarity",
    "module": 1,
    "parentKey": "m1-7-orphan",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-7-2-market-exclusivity",
    "code": "1.7.2",
    "title": "Market Exclusivity",
    "module": 1,
    "parentKey": "m1-7-orphan",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-8-pharmacovigilance",
    "code": "1.8",
    "title": "Pharmacovigilance",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [
      "m1-8-1-pharmacovigilance-system",
      "m1-8-2-risk-management-system"
    ],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-8-1-pharmacovigilance-system",
    "code": "1.8.1",
    "title": "Pharmacovigilance System",
    "module": 1,
    "parentKey": "m1-8-pharmacovigilance",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-8-2-risk-management-system",
    "code": "1.8.2",
    "title": "Risk Management System",
    "module": 1,
    "parentKey": "m1-8-pharmacovigilance",
    "childKeys": [],
    "depth": 2,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-9-clinical-trials",
    "code": "1.9",
    "title": "Clinical Trials",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-10-paediatrics",
    "code": "1.10",
    "title": "Paediatrics",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-responses",
    "code": "1",
    "title": "Responses",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  },
  {
    "key": "m1-additional-data",
    "code": "1",
    "title": "Additional Data",
    "module": 1,
    "parentKey": "m1-eu",
    "childKeys": [],
    "depth": 1,
    "repeatable": false,
    "optional": true,
    "contextAttributes": []
  }
];
